import * as React from 'react';
import { Button } from '../../../../../designSystem/button/Button';
import { iconName } from '../../../../../designSystem/icons/Icons';

export function CooldownButton (props: CooldownButtonProps): JSX.Element
{
    return (
        <Button
            variant='outlined'
            text={props.cooldown > 0 ? props.cooldown.toString() : undefined}
            icon={props.icon}
            toolTipText={props.cooldown ? 'Retsinfo kan kun tilgås hvert 10. sekund - afventer' : props.toolTipText}
            disabled={props.cooldown > 0}
            onClick={props.onClick} />
    );
}
export type CooldownButtonProps = {
    icon: iconName;
    toolTipText: string;
    onClick: () => void;
    cooldown: number;
};

